module.exports = __webpack_public_path__ + "img/11.761cbd4d.jpg";